import { ProcessSignalNumber } from "Api/adminAgent/types/ProcessSignal.enum";
import { ServiceProcess } from "Api/adminAgent/types/ServiceProcess.type";
import { useAppDispatch } from "Store/hooks";

import { openProcessActionModal } from "../serviceProcesses.slice";

export const useOpenProcessActionModal = () => {
  const dispatch = useAppDispatch();

  const openModal = (process: ServiceProcess, signal: ProcessSignalNumber) => {
    dispatch(
      openProcessActionModal({
        signal,
        process
      })
    );
  };

  return openModal;
};
